export default __webpack_public_path__ + "static/media/57.8a72e98c.jpg";